import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { calendarPreferencesMock } from '../mockData/user-calendar-preference-data';

const UserDevicesApi = [
  rest.get(`${API_ROOT}user-calendar-preferences`, (req, res, ctx) => res(ctx.json(calendarPreferencesMock))),
  rest.post(`${API_ROOT}user-calendar-preferences`, (req, res, ctx) => res(ctx.json({ success: true }))),
];

export default UserDevicesApi;
